<template>
  <div class="detail-container">
    <!-- 导航栏 -->

    <van-nav-bar class="page-nav-bar" title="客户卡片" left-arrow @click-left="$router.back()"></van-nav-bar>
    <!-- /导航栏 -->

    <!-- 客户详情 -->
    <div class="box-radius">
      <van-row type="flex" justify="space-between">
        <van-col class="bold-text">北京超图科技有限公司</van-col>
        <van-col>
          <van-icon name="edit" size="0.5rem" />
        </van-col>
      </van-row>
      <van-row class="mobile-text">
        <van-col span="12">手机：</van-col>
        <van-col span="12">地区：</van-col>
        <van-col span="12">手机：</van-col>
        <van-col span="12">微信号：</van-col>
        <van-col span="24">微信昵称：</van-col>
        <van-col span="24">地址：</van-col>
      </van-row>
    </div>
    <!-- /客户详情 -->
    <!-- 合同订单 -->
    <div class="box-radius">
      <!-- 第一行 -->
      <van-row class="box-margin">
        <van-col span="6">
          <van-row>
            <van-col>
              <van-icon name="manager-o" size="0.5rem" />
            </van-col>
            <van-col class="vertical">
              <b>合同</b>
              <div>数量1个</div>
            </van-col>
          </van-row>
        </van-col>

        <van-col span="6">
          <van-row>
            <van-col>
              <van-icon name="manager-o" size="0.5rem" />
            </van-col>
            <van-col class="vertical">
              <b>合同</b>
              <div>数量1个</div>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="6">
          <van-row>
            <van-col>
              <van-icon name="manager-o" size="0.5rem" />
            </van-col>
            <van-col class="vertical">
              <b>合同</b>
              <div>数量1个</div>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="6">
          <van-row>
            <van-col>
              <van-icon name="manager-o" size="0.5rem" />
            </van-col>
            <van-col class="vertical">
              <b>合同</b>
              <div>数量1个</div>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <!-- 第二行 -->
      <van-row class="box-margin">
        <van-col span="12">
          <van-row>
            <van-col>
              <van-icon name="manager-o" size="0.5rem" />
            </van-col>
            <van-col class="vertical">
              <b>合同</b>
              <div>数量1个</div>
              <div>数量1个</div>
              <div>数量1个</div>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="12">
          <van-row>
            <van-col>
              <van-icon name="manager-o" size="0.5rem" />
            </van-col>
            <van-col class="vertical">
              <b>合同</b>
              <div>数量1个</div>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
    <!-- /合同订单 -->
    <!-- 联系记录 -->
    <van-cell class="box-content">
      <!-- 第一行 -->
      <van-row class="gray-text" type="flex" justify="space-between">
        <van-col>联系记录(2)</van-col>
        <van-col>
          <van-icon name="plus" size="0.5rem" />
        </van-col>
      </van-row>
      <!-- 第二行 -->
      <van-row type="flex" class="row-border">
        <van-col span="4">头像</van-col>
        <van-col span="20">
          <span class="max-text">刘立飞</span>
          <span class="max-text">【打电话】</span>
          <div class="min-text">
            问问吾问无为谓问1111111无无无翁玩玩无无无无无无
            问问吾问无为谓问1111111无无无翁玩玩无无无无无无
          </div>
          <van-row>
            <van-col span="18" class="time-text">来自pc web 2021-01-18 13:51:41</van-col>
            <van-col span="3">
              <van-icon name="chat-o" size="0.5rem" />
            </van-col>
            <van-col span="3">
              <van-icon name="share-o" size="0.5rem" />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <!-- 第二行 -->
      <van-row type="flex" class="row-border">
        <van-col span="4">头像</van-col>
        <van-col span="20">
          <span class="max-text">刘立飞</span>
          <span class="max-text">【打电话】</span>
          <div class="min-text">
            问问吾问无为谓问1111111无无无翁玩玩无无无无无无
          </div>
          <van-row>
            <van-col span="18" class="time-text">来自pc web 2021-01-18 13:51:41</van-col>
            <van-col span="3">
              <van-icon name="chat-o" size="0.5rem" />
            </van-col>
            <van-col span="3">
              <van-icon name="share-o" size="0.5rem" />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </van-cell>
    <!-- /联系记录 -->
    <!-- footer -->
    <van-tabbar v-model="active">
      <van-tabbar-item icon="comment-o">反馈</van-tabbar-item>
      <van-tabbar-item icon="star-o">关注</van-tabbar-item>
      <van-tabbar-item icon="cluster-o">共享</van-tabbar-item>
      <van-tabbar-item icon="calendar-o">纪念日</van-tabbar-item>
      <van-tabbar-item icon="ellipsis">更多</van-tabbar-item>
    </van-tabbar>
    <!-- /footer -->
  </div>
</template>

<script>
export default {
  name: 'DetailIndex',
  components: {},
  props: {},
  data() {
    return {
      active: 0
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>

<style scoped lang='less'>
//圆角盒子
.box-radius {
  padding: 20px;
}

.bold-text {
  font-size: 30px;
  font-weight: bold;
}
.mobile-text {
  font-size: 25px;
  color: #c7c7c7;
}

.vertical {
  font-size: 25px;
  b {
    display: block;
  }
}

.box-margin {
  margin-bottom: 20px;
}

.box-content {
  padding: 30px 30px 0 30px;
  background-color: #fff;
  .row-border {
    margin-top: 20px;
    border-bottom: 1px solid #f6f5f6;
  }
  .gray-text {
    font-weight: 700;
    margin-bottom: 10px;
    color: gray;
  }
  .max-text {
    font-weight: 700;
  }
  .min-text {
    margin: 10px 0;
  }
  .time-text {
    font-size: 25px;
    color: gray;
  }
}
</style>